import ResetPassword, { action as resetPasswordAction } from './ResetPassword';

export default ResetPassword;
export { resetPasswordAction };
